import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function convertToSlug(inputString) {
  if (inputString) {
    return inputString
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^\w-]+/g, '') // Remove non-word characters (excluding hyphens)
      .replace(/--+/g, '-'); // Replace multiple hyphens with a single hyphen
  }
}

export function formatDate(dateString) {
  try {
    return format(new Date(dateString), 'EEEE, MMMM do, yyyy');
  } catch (error) {
    console.error('Invalid date:', dateString);
    return '';
  }
}

export function formatReadTime(value) {
  if (!value) return '';
  // Extract number from any format
  const minutes = value.toString().match(/\d+/)?.[0];
  if (!minutes) return value;
  // Return normalized output
  return `${minutes} min read`;
}
